(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[25],{

/***/ "+3y+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isPledgAllowed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchPledg; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("JtPf");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kiXb");





var pledgApiPath = "".concat(_config__WEBPACK_IMPORTED_MODULE_3___default.a.get('psp.pledg.api_path'), "/").concat(_config__WEBPACK_IMPORTED_MODULE_3___default.a.get('psp.pledg.merchand_id'));
var isPledgAllowed = function isPledgAllowed(_ref) {
  var price = _ref.price;
  var MAXIMUM_PLEDG_AMOUNT = Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* getKeyValue */ "d"])('booking.banking.paymentSchedule.bnpl.pledgMaxAmount');
  return price <= MAXIMUM_PLEDG_AMOUNT;
};
var fetchPledg = function fetchPledg(endpoint, options) {
  return fetch("".concat(pledgApiPath).concat(endpoint), options).then(function (response) {
    return response.json();
  });
};

/***/ }),

/***/ "7E63":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccordionItem; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("C/y5");
/* harmony import */ var react_collapse__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("3OwS");
/* harmony import */ var react_collapse__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_collapse__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("SPKZ");
/* harmony import */ var _tracking_tracking_api_useTrackEvent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("DqI1");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("qBqs");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;






var AccordionItem = function AccordionItem(_ref) {
  var bottomLeft = _ref.bottomLeft,
      bottomRight = _ref.bottomRight,
      children = _ref.children,
      component = _ref.component,
      dataTestId = _ref.dataTestId,
      iconName = _ref.iconName,
      isFirstItem = _ref.isFirstItem,
      isLastItem = _ref.isLastItem,
      isNull = _ref.isNull,
      isOpenedByDefault = _ref.isOpenedByDefault,
      topLeft = _ref.topLeft,
      topRight = _ref.topRight,
      trackingData = _ref.trackingData;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(isOpenedByDefault),
      isOpened = _useState[0],
      setIsOpened = _useState[1];

  var _useTrackEvent = Object(_tracking_tracking_api_useTrackEvent__WEBPACK_IMPORTED_MODULE_4__[/* useTrackEvent */ "a"])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  if (component) {
    return __jsx("div", {
      className: "mt-30"
    }, component);
  }

  return !isNull && __jsx(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, null, __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])('mb-15 flex gap-20', {
      'border-t-1 border-dashed pt-10': !isFirstItem && !isLastItem,
      'mt-30 border-t-5 pt-10': !isFirstItem && isLastItem
    })
  }, iconName && __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__[/* Icon */ "a"], {
    className: "text-sienna",
    name: iconName,
    width: "1.875rem"
  }), __jsx("div", {
    className: "grid w-full grid-cols-2"
  }, __jsx("div", {
    className: "grid"
  }, __jsx("p", {
    className: "text-14"
  }, topLeft), bottomLeft && __jsx("p", {
    className: "text-14 font-bold"
  }, bottomLeft)), __jsx("div", {
    className: "grid max-h-40 justify-end"
  }, __jsx("p", {
    className: "text-end text-14"
  }, topRight), bottomRight && __jsx("p", {
    className: "text-end text-14 font-bold text-orange"
  }, bottomRight)))), children && __jsx("div", {
    className: "flex w-full justify-end"
  }, __jsx("button", {
    "data-testid": dataTestId,
    type: "button",
    onClick: function onClick() {
      if (trackingData && !isOpened) {
        trackClickEvent(trackingData.event, trackingData.payload);
      }

      setIsOpened(!isOpened);
    }
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__[/* Icon */ "a"], {
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].ARROW_TOP,
    rotation: isOpened ? 0 : 180
  }))), __jsx(react_collapse__WEBPACK_IMPORTED_MODULE_2__["UnmountClosed"], {
    isOpened: isOpened
  }, children));
};

/***/ }),

/***/ "AV+p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return computePriceInCents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isAllowedPaymentPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return submitBuyNowPayLater; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isIframeBuyNowPayLaterProvider; });
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_math_trunc__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("Wd/2");
/* harmony import */ var core_js_modules_es_math_trunc__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_math_trunc__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _PaymentInfo_const__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("BU6i");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("kiXb");
/* harmony import */ var _pledg_form_PledgForm_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+3y+");







var MAXIMUM_DAYS_BEFORE_DEPARTURE = 45;

var isBeforeDepartureLimit = function isBeforeDepartureLimit(_ref) {
  var startDate = _ref.startDate;
  var dayBeforeDeparture = moment__WEBPACK_IMPORTED_MODULE_4___default()(startDate, 'YYYYMMDD').diff(moment__WEBPACK_IMPORTED_MODULE_4___default()(), 'days');
  return dayBeforeDeparture < MAXIMUM_DAYS_BEFORE_DEPARTURE;
};

var isOneyAllowed = function isOneyAllowed(_ref2) {
  var price = _ref2.price;
  var maximumAllowedAmount = Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* getKeyValue */ "d"])('booking.banking.paymentSchedule.bnpl.maxAmount');
  return price <= maximumAllowedAmount;
};

var computePriceInCents = function computePriceInCents(price) {
  return Math.trunc(price * 100);
};
var isAllowedPaymentPlan = function isAllowedPaymentPlan(_ref3) {
  var id = _ref3.id,
      price = _ref3.price,
      startDate = _ref3.startDate;

  if (id === _PaymentInfo_const__WEBPACK_IMPORTED_MODULE_3__[/* PLEDG_PSP_ID */ "o"]) {
    return Object(_pledg_form_PledgForm_utils__WEBPACK_IMPORTED_MODULE_6__[/* isPledgAllowed */ "b"])({
      price: price
    }) && isBeforeDepartureLimit({
      startDate: startDate
    });
  }

  if (id === _PaymentInfo_const__WEBPACK_IMPORTED_MODULE_3__[/* ONEY_PSP_ID */ "k"]) {
    return isOneyAllowed({
      price: price
    }) && isBeforeDepartureLimit({
      startDate: startDate
    });
  }

  return true;
};
var submitBuyNowPayLater = function submitBuyNowPayLater(paymentPlanId) {
  switch (paymentPlanId) {
    case _PaymentInfo_const__WEBPACK_IMPORTED_MODULE_3__[/* UPLIFT_PSP_ID */ "p"]:
      window.Uplift.Payments.getToken();
      break;

    default:
      break;
  }
};
var isIframeBuyNowPayLaterProvider = function isIframeBuyNowPayLaterProvider(paymentPlanId) {
  return [_PaymentInfo_const__WEBPACK_IMPORTED_MODULE_3__[/* UPLIFT_PSP_ID */ "p"], _PaymentInfo_const__WEBPACK_IMPORTED_MODULE_3__[/* PLEDG_PSP_ID */ "o"]].includes(paymentPlanId);
};

/***/ }),

/***/ "Djgd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return roomQuantity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getNbAccommodations; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_3__);




var roomQuantity = function roomQuantity(accommodations) {
  return accommodations.filter(function (accommodation) {
    return accommodation.quantity > 1;
  }).map(function (accommodation) {
    return accommodation.quantity;
  });
};
var getNbAccommodations = function getNbAccommodations(accommodationsSet) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(accommodationsSet, 'accommodations', []).reduce(function (acc, accommodation) {
    return acc + lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(accommodation, 'quantity', 0);
  }, 0);
};

/***/ }),

/***/ "FkdH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StaySummaryTicketUpsell; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("C/y5");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;



var StaySummaryTicketUpsell = function StaySummaryTicketUpsell(_ref) {
  var _price$transfer, _price$childcare, _price$childcare2;

  var childcares = _ref.childcares,
      price = _ref.price,
      transferUpsell = _ref.transferUpsell;
  var transferFormattedValue = price === null || price === void 0 ? void 0 : (_price$transfer = price.transfer) === null || _price$transfer === void 0 ? void 0 : _price$transfer.formattedValue;
  var childcareFormattedValue = price === null || price === void 0 ? void 0 : (_price$childcare = price.childcare) === null || _price$childcare === void 0 ? void 0 : _price$childcare.formattedValue;
  var childcarePrice = price === null || price === void 0 ? void 0 : (_price$childcare2 = price.childcare) === null || _price$childcare2 === void 0 ? void 0 : _price$childcare2.value;
  var isIncluded = (childcares === null || childcares === void 0 ? void 0 : childcares.filter(function (el) {
    return !!el.productInfo.isIncluded && !!el.pricingInfo.isPartiallyRented;
  }).length) > 0;
  var isOnDemand = (childcares === null || childcares === void 0 ? void 0 : childcares.filter(function (el) {
    return !el.productInfo.isIncluded && !!el.pricingInfo.isPartiallyRented;
  }).length) > 0;

  var mention = function mention() {
    if (isIncluded && isOnDemand) {
      return null;
    }

    if (isIncluded) {
      return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.common.included');
    }

    if (isOnDemand) {
      return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.confirmation.onDemand');
    }
  };

  if (childcares) {
    return __jsx(react__WEBPACK_IMPORTED_MODULE_1___default.a.Fragment, null, __jsx("p", {
      className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('text-14', {
        'text-orange font-bold': isOnDemand,
        'text-green font-bold': isIncluded
      })
    }, mention()), __jsx("p", {
      className: "text-14 text-orange font-bold"
    }, childcarePrice > 0 && "+".concat(childcareFormattedValue)));
  }

  if (transferUpsell) {
    return __jsx(react__WEBPACK_IMPORTED_MODULE_1___default.a.Fragment, null, __jsx("p", {
      className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('text-14', {
        'text-saffron': !transferUpsell,
        'text-orange font-bold': transferUpsell
      })
    }, transferUpsell ? Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.confirmation.onDemand') : Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.common.included')), __jsx("p", {
      className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('text-14 font-bold', {
        'text-orange': transferUpsell
      })
    }, "+ ", transferFormattedValue));
  }
};

/***/ }),

/***/ "LALX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export displayUpsellNames */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return displayActivitiesAndEquipmentsNames; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);





/* eslint-disable max-params */
var displayUpsellNames = function displayUpsellNames(upsells) {
  var _upsellAttendees$filt;

  var getUpsellsNames = upsells === null || upsells === void 0 ? void 0 : upsells.map(function (upsell) {
    var _upsell$productInfo;

    return upsell === null || upsell === void 0 ? void 0 : (_upsell$productInfo = upsell.productInfo) === null || _upsell$productInfo === void 0 ? void 0 : _upsell$productInfo.label;
  });
  var upsellAttendees = upsells === null || upsells === void 0 ? void 0 : upsells.map(function (upsell, index) {
    var _upsell$pricingInfo, _upsell$pricingInfo$a, _upsell$pricingInfo2, _upsell$pricingInfo2$;

    return (upsell === null || upsell === void 0 ? void 0 : (_upsell$pricingInfo = upsell.pricingInfo) === null || _upsell$pricingInfo === void 0 ? void 0 : (_upsell$pricingInfo$a = _upsell$pricingInfo.attendees) === null || _upsell$pricingInfo$a === void 0 ? void 0 : _upsell$pricingInfo$a.filter(function (el) {
      var _el$rentedAmount;

      return (el === null || el === void 0 ? void 0 : (_el$rentedAmount = el.rentedAmount) === null || _el$rentedAmount === void 0 ? void 0 : _el$rentedAmount.value) > 0;
    }).length) > 0 ? "".concat(upsell === null || upsell === void 0 ? void 0 : (_upsell$pricingInfo2 = upsell.pricingInfo) === null || _upsell$pricingInfo2 === void 0 ? void 0 : (_upsell$pricingInfo2$ = _upsell$pricingInfo2.attendees) === null || _upsell$pricingInfo2$ === void 0 ? void 0 : _upsell$pricingInfo2$.filter(function (el) {
      var _el$rentedAmount2;

      return (el === null || el === void 0 ? void 0 : (_el$rentedAmount2 = el.rentedAmount) === null || _el$rentedAmount2 === void 0 ? void 0 : _el$rentedAmount2.value) > 0;
    }).length, " ").concat(getUpsellsNames[index]) : null;
  });
  return (_upsellAttendees$filt = upsellAttendees.filter(function (upsell) {
    return upsell;
  })) === null || _upsellAttendees$filt === void 0 ? void 0 : _upsellAttendees$filt.join(' | ');
};
var displayActivitiesAndEquipmentsNames = function displayActivitiesAndEquipmentsNames(hasActivities, hasEquipments, activities, equipments) {
  if (hasActivities && !hasEquipments) {
    return displayUpsellNames(activities);
  }

  if (!hasActivities && hasEquipments) {
    return displayUpsellNames(equipments);
  }

  if (hasEquipments) {
    return "".concat(displayUpsellNames(activities), " | ").concat(displayUpsellNames(equipments));
  }
};

/***/ }),

/***/ "MZRd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadUplift; });
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("WNMA");
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_1__);



/* eslint-disable */
var loadUplift = function loadUplift(upliftCode) {
  (function (u, p, l, i, f, t, o, b, j) {
    u.UpLiftPlatformObject = f;
    u[f] = u[f] || function () {
      (u[f].q = u[f].q || []).push(arguments);
    }, u[f].l = 1 * new Date();
    b = p.createElement(l), j = p.getElementsByTagName(l)[0];
    b.async = 1;
    b.src = i + '?id=' + t;
    j.parentNode.insertBefore(b, j);
    o = u.location.host.match(/[\w-]+\.\w{2,3}(:\d+)?$/);

    if (o) {
      o = o[0];
    }

    u[f]('create', t, o);
  })(window, document, 'script', 'https://cdn.uplift-platform.com/a/up.js', 'up', upliftCode);
};

/***/ }),

/***/ "NYMU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return trackUplift; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildOrder; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_flat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ulNE");
/* harmony import */ var core_js_modules_es_array_flat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_flat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_unscopables_flat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("urw/");
/* harmony import */ var core_js_modules_es_array_unscopables_flat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_unscopables_flat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _frameworks_datepicker_Datepicker_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("szYs");
/* harmony import */ var _BuyNowPayLater_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("AV+p");






/* eslint-disable camelcase */



var trackUplift = function trackUplift(_ref) {
  var orderId = _ref.orderId,
      isErrored = _ref.isErrored,
      errorMsg = _ref.errorMsg;

  if (isErrored) {
    window.Uplift.Payments.error(errorMsg, 'fatal');
  } else {
    window.Uplift.Analytics.orderResponse({
      mode_of_payment: 'pay monthly',
      order_id: orderId
    });
    window.Uplift.Payments.confirm(orderId);
  }
};

var buildOrder = function buildOrder(_ref2) {
  var price = _ref2.price,
      accommodations = _ref2.accommodations,
      departureDate = _ref2.departureDate,
      arrivalDate = _ref2.arrivalDate,
      name = _ref2.name,
      attendees = _ref2.attendees,
      transports = _ref2.transports;
  var mappedAttendees = (attendees || []).map(function (_ref3, index) {
    var firstName = _ref3.firstName,
        lastName = _ref3.lastName,
        email = _ref3.email,
        mobilePhoneNumber = _ref3.mobilePhoneNumber,
        dateOfBirth = _ref3.dateOfBirth,
        birthday = _ref3.birthday,
        _ref3$address = _ref3.address;
    _ref3$address = _ref3$address === void 0 ? {} : _ref3$address;
    var city = _ref3$address.city,
        countryCode = _ref3$address.countryCode,
        stateOrDistrict = _ref3$address.stateOrDistrict,
        streetName = _ref3$address.streetName,
        streetNumber = _ref3$address.streetNumber,
        zipCode = _ref3$address.zipCode;
    return {
      id: index,
      first_name: firstName,
      last_name: lastName,
      email: email,
      phone: mobilePhoneNumber,
      date_of_birth: Object(_frameworks_datepicker_Datepicker_utils__WEBPACK_IMPORTED_MODULE_5__["formatDate"])(dateOfBirth || birthday, 'MM/DD/YYYY'),
      street_address: streetName && "".concat(streetNumber, " ").concat(streetName),
      city: city,
      region: stateOrDistrict,
      country: countryCode,
      postal_code: zipCode
    };
  });
  var billing_contact = mappedAttendees[0];
  var travelers = mappedAttendees.map(function (_ref4) {
    var id = _ref4.id,
        first_name = _ref4.first_name,
        last_name = _ref4.last_name,
        date_of_birth = _ref4.date_of_birth;
    return {
      id: id,
      first_name: first_name,
      last_name: last_name,
      date_of_birth: date_of_birth
    };
  });
  var air_reservations = [];

  if (transports === null || transports === void 0 ? void 0 : transports.length) {
    var inboundTransport = (transports === null || transports === void 0 ? void 0 : transports[0]) || [];
    var _inboundTransport$ = inboundTransport[0],
        company = _inboundTransport$.company,
        origin = _inboundTransport$.origin;
    var destination = inboundTransport[inboundTransport.length - 1].destination;
    air_reservations = [{
      airline_name: company.name,
      origin: origin,
      destination: destination,
      trip_type: 'roundtrip',
      itinerary: transports.flat().map(function (_ref5) {
        var departure = _ref5.departure,
            arrival = _ref5.arrival,
            carrier_code = _ref5.company.id;
        return {
          departure_apc: departure.apc,
          departure_time: departure.date,
          arrival_apc: arrival.apc,
          arrival_time: arrival.date,
          fare_class: 'Economy',
          carrier_code: carrier_code
        };
      }),
      insurance: []
    }];
  }

  return {
    order_amount: Object(_BuyNowPayLater_utils__WEBPACK_IMPORTED_MODULE_6__[/* computePriceInCents */ "a"])(price || 0),
    travelers: travelers,
    add_ons: [],
    billing_contact: billing_contact,
    air_reservations: air_reservations,
    hotel_reservations: [{
      hotel_name: name,
      number_of_rooms: (accommodations === null || accommodations === void 0 ? void 0 : accommodations.count) || 1,
      room_type: (accommodations === null || accommodations === void 0 ? void 0 : accommodations.name) || '',
      check_in: departureDate,
      check_out: arrivalDate
    }]
  };
};



/***/ }),

/***/ "UY1v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ChildcareSummary_ChildcareSummary; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/utils/string/string.util.js
var string_util = __webpack_require__("tX1K");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// CONCATENATED MODULE: ./src/client/components/widgets/childcare-description/ChildcareDescription.jsx


var __jsx = react_default.a.createElement;







var ChildcareDescription_ChildcareDescription = function ChildcareDescription(_ref) {
  var description = _ref.description;

  var _useState = Object(react["useState"])(false),
      isExpanded = _useState[0],
      setIsExpanded = _useState[1];

  return __jsx("div", null, __jsx(lib["Collapse"], {
    initialStyle: {
      minHeight: 45
    },
    isOpened: isExpanded
  }, __jsx("div", {
    className: "flex flex-col"
  }, __jsx("button", {
    className: "py-5 text-start",
    type: "button",
    onClick: function onClick() {
      return setIsExpanded(!isExpanded);
    }
  }, !!description && __jsx(Text["a" /* Text */], {
    className: Object(classnames_utils["a" /* classnames */])({
      'line-clamp-2': !isExpanded
    }),
    text: isExpanded ? description : Object(string_util["d" /* truncate */])(description, 150, true)
  }))), __jsx("div", {
    className: "text-right"
  }, __jsx("button", {
    type: "button",
    onClick: function onClick() {
      return setIsExpanded(!isExpanded);
    }
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ARROW_TOP,
    rotation: isExpanded ? 0 : 180
  })))));
};
// EXTERNAL MODULE: ./src/client/components/utils/product/product.utils.js
var product_utils = __webpack_require__("C9cF");

// EXTERNAL MODULE: ./src/utils/childcare/childcare.utils.js
var childcare_utils = __webpack_require__("erJz");

// EXTERNAL MODULE: ./src/client/components/widgets/childcare-summary/ChildcareSummary.utils.js
var ChildcareSummary_utils = __webpack_require__("AinJ");

// CONCATENATED MODULE: ./src/client/components/widgets/childcare-summary/ChildcareSummary.jsx






var ChildcareSummary_jsx = react_default.a.createElement;







var ChildcareSummary_ChildcareSummary = function ChildcareSummary(_ref) {
  var childcares = _ref.childcares;
  var childcaresFiltered = childcares.filter(function (childcare) {
    var _currentChildInfo$ren;

    var _childcare$pricingInf = childcare.pricingInfo,
        childId = _childcare$pricingInf.childId,
        attendees = _childcare$pricingInf.attendees;
    var isIncluded = childcare.productInfo.isIncluded;
    var currentChildInfo = attendees.find(function (_ref2) {
      var id = _ref2.id;
      return id === childId;
    });
    return (currentChildInfo === null || currentChildInfo === void 0 ? void 0 : (_currentChildInfo$ren = currentChildInfo.rentedAmount) === null || _currentChildInfo$ren === void 0 ? void 0 : _currentChildInfo$ren.value) > 0 || isIncluded;
  });

  if (childcaresFiltered.length === 0) {
    return null;
  }

  return ChildcareSummary_jsx("div", {
    className: "mt-30"
  }, childcaresFiltered.map(function (childcare, idx) {
    var _childcare$productInf = childcare.productInfo,
        label = _childcare$productInf.label,
        description = _childcare$productInf.description,
        ageInMonths = _childcare$productInf.ageInMonths;
    var _childcare$pricingInf2 = childcare.pricingInfo,
        childId = _childcare$pricingInf2.childId,
        attendees = _childcare$pricingInf2.attendees;
    var currentChildInfo = attendees.find(function (_ref3) {
      var id = _ref3.id;
      return id === childId;
    });
    var currentChildRentedAmout = currentChildInfo === null || currentChildInfo === void 0 ? void 0 : currentChildInfo.rentedAmount;
    var childcareRentedSpecificLabel = Object(ChildcareSummary_utils["a" /* getSpecificChildcareLabel */])(currentChildInfo);
    var childcareTitle = "".concat(label, " - ").concat(childcareRentedSpecificLabel);
    var rentedOrPaidTimeSlots = currentChildInfo.schedules[0].timeSlots.filter(function (_ref4) {
      var isRented = _ref4.isRented,
          isPaid = _ref4.isPaid;
      return isRented || isPaid;
    });
    return ChildcareSummary_jsx(react_default.a.Fragment, {
      key: childcare.id
    }, ChildcareSummary_jsx("p", {
      className: "mt-0 mb-10 text-20 font-bold"
    }, "".concat(Object(i18n["h" /* t */])('booking.confirmation.child'), " ").concat(idx + 1)), ChildcareSummary_jsx("div", {
      className: "bg-white rounded-12 shadow-sm mb-20 p-20"
    }, ChildcareSummary_jsx("div", {
      className: "flex justify-between items-end"
    }, ChildcareSummary_jsx("div", {
      className: "flex w-full"
    }, ChildcareSummary_jsx("div", {
      className: "flex w-full justify-between"
    }, ChildcareSummary_jsx("div", {
      className: "flex flex-col w-4/5"
    }, ChildcareSummary_jsx("p", {
      className: "text-brand text-blue font-bold mt-0 mb-20"
    }, childcareTitle), ChildcareSummary_jsx("div", {
      className: "flex gap-10 items-center"
    }, ChildcareSummary_jsx(Icon["a" /* Icon */], {
      name: "duration",
      width: "0.9375em"
    }), ChildcareSummary_jsx(childcare_utils["a" /* DurationSlotsLabels */], {
      timeSlots: childcare.productInfo.timeSlots || [],
      closingWeekdays: childcare.productInfo.closingWeekdays || [],
      rentedOrPaidTimeSlots: rentedOrPaidTimeSlots,
      showOnlyRentedOrPaid: true
    })), ChildcareSummary_jsx("div", {
      className: "flex gap-10 items-center"
    }, ChildcareSummary_jsx(Icon["a" /* Icon */], {
      name: "dateStar",
      width: "0.9375em"
    }), ChildcareSummary_jsx("p", {
      className: "text-14"
    }, Object(product_utils["f" /* getServiceAgesLabel */])(ageInMonths)))), ChildcareSummary_jsx("div", {
      className: "flex flex-col text-right"
    }, ChildcareSummary_jsx("p", {
      className: "font-bold"
    }, Object(ChildcareSummary_utils["c" /* rentedTotalPriceByChild */])(childcare, currentChildRentedAmout)))))), ChildcareSummary_jsx(ChildcareDescription_ChildcareDescription, {
      description: description
    })));
  }));
};

/***/ }),

/***/ "Wd/2":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("ax0f");

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
$({ target: 'Math', stat: true }, {
  trunc: function trunc(it) {
    return (it > 0 ? floor : ceil)(it);
  }
});


/***/ }),

/***/ "X3Cs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getOffersAndDiscounts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPriceDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasPersonRentedAnUpsell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSummaryViewLinesByProposal; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("SPKZ");
/* harmony import */ var _components_widgets_be_transport_details_BeTransportDetails__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("a2Xc");
/* harmony import */ var _components_widgets_stay_summary_ticket_GetParticipantsActivities__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("gAE7");
/* harmony import */ var _components_widgets_stay_summary_ticket_StaySummaryTicketUpsell__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("FkdH");
/* harmony import */ var _components_widgets_stay_summary_ticket_StaySummaryTicket_utils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("s2zd");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("oL6k");
/* harmony import */ var _components_widgets_childcare_summary_ChildcareSummary__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("UY1v");
/* harmony import */ var _utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("wz9x");
/* harmony import */ var _utils_activity_activity_utils__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("LALX");
/* harmony import */ var _utils_childcare_childcare_utils__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("erJz");
/* harmony import */ var _utils_accommodation_accommodation_utils__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("Djgd");
/* harmony import */ var _utils_participants_participants_utils__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("WeO/");
/* harmony import */ var _components_widgets_bottom_navbar_layer_SelectedRate__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("sEDY");
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("C/y5");
/* harmony import */ var _components_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("qBqs");
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("829J");









var __jsx = react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement;



















var FLEX_RATES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_10__["constants"].FLEX_RATES,
    OFFERS = _clubmed_utils__WEBPACK_IMPORTED_MODULE_10__["constants"].OFFERS;
var getOffersAndDiscounts = function getOffersAndDiscounts(proposalDiscounts) {
  var discounts = proposalDiscounts.filter(function (discount) {
    return discount.offerId === OFFERS.PROMO_CODE;
  });
  var offers = proposalDiscounts.filter(function (discount) {
    return discount.offerId !== OFFERS.PROMO_CODE;
  });
  return {
    offers: offers,
    discounts: discounts
  };
};
var getPriceDetail = function getPriceDetail(_ref) {
  var _selectedProposal$pri5, _selectedProposal$pri6;

  var selectedProposal = _ref.selectedProposal,
      priceWithDonation = _ref.priceWithDonation,
      showPriceDetailLines = _ref.showPriceDetailLines,
      promoCode = _ref.promoCode,
      insurance = _ref.insurance;

  var insuranceValue = function insuranceValue() {
    var _selectedProposal$pri, _selectedProposal$pri2, _selectedProposal$pri3, _selectedProposal$pri4;

    if (selectedProposal.price.insurance === undefined || ((_selectedProposal$pri = selectedProposal.price) === null || _selectedProposal$pri === void 0 ? void 0 : (_selectedProposal$pri2 = _selectedProposal$pri.insurance) === null || _selectedProposal$pri2 === void 0 ? void 0 : _selectedProposal$pri2.value) === null) {
      return null;
    }

    return (_selectedProposal$pri3 = selectedProposal.price) === null || _selectedProposal$pri3 === void 0 ? void 0 : (_selectedProposal$pri4 = _selectedProposal$pri3.insurance) === null || _selectedProposal$pri4 === void 0 ? void 0 : _selectedProposal$pri4.formattedValue;
  };

  var taxes = (_selectedProposal$pri5 = selectedProposal.price) === null || _selectedProposal$pri5 === void 0 ? void 0 : (_selectedProposal$pri6 = _selectedProposal$pri5.fees) === null || _selectedProposal$pri6 === void 0 ? void 0 : _selectedProposal$pri6.reduce(function (acc, _ref2) {
    var type = _ref2.type,
        amount = _ref2.amount;
    acc[type] = amount.formattedValue;
    return acc;
  }, {});
  var price = priceWithDonation.withDonation;
  var totalPrice = selectedProposal.price.total.formattedValue;
  var selectedRate = price && price.hasFlexRates && price.selectedRate ? __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_25__[/* classnames */ "a"])('mt-5 rounded-pill px-10 py-5', {
      'bg-green': price.selectedRate === FLEX_RATES.STANDARD,
      'bg-sienna': price.selectedRate === FLEX_RATES.NRR || price.selectedRate === FLEX_RATES.FLR
    })
  }, __jsx(_components_widgets_bottom_navbar_layer_SelectedRate__WEBPACK_IMPORTED_MODULE_24__[/* SelectedRate */ "a"], {
    price: price
  })) : null;
  var priceDetail = [{
    iconName: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_11__[/* ICONS */ "a"].DISHES,
    dataTestId: 'dishes-button',
    topLeft: Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('booking.accommodation.packageContent.allInclusiveReassurance.cuisine.message'),
    topRight: Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('common.included'),
    children: __jsx("p", {
      className: "mb-10 text-14"
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('booking.accommodation.packageContent.allInclusiveReassuranceCuisineDetailedDescription')),
    isFirstItem: true,
    trackingData: {
      event: _tracking_constants__WEBPACK_IMPORTED_MODULE_27__[/* TRACK_EVENT_NAMES */ "F"].CLICK_RECEIPT_TICKET,
      payload: {
        detail_click: 'price_details_receipt_food'
      }
    }
  }, {
    iconName: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_11__[/* ICONS */ "a"].BAR,
    dataTestId: 'bar-button',
    topLeft: Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('booking.accommodation.packageContent.allInclusiveReassurance.bar.message'),
    topRight: Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('common.included'),
    children: __jsx("p", {
      className: "mb-10 text-14"
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('booking.accommodation.packageContent.allInclusiveReassuranceBarDetailedDescription')),
    trackingData: {
      event: _tracking_constants__WEBPACK_IMPORTED_MODULE_27__[/* TRACK_EVENT_NAMES */ "F"].CLICK_RECEIPT_TICKET,
      payload: {
        detail_click: 'price_details_receipt_beverage'
      }
    }
  }, {
    iconName: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_11__[/* ICONS */ "a"].TENNIS,
    dataTestId: 'price-activities-button',
    topLeft: Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('booking.accommodation.packageContent.allInclusiveReassurance.sportAndActivities.message'),
    topRight: Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('common.included'),
    children: __jsx("p", {
      className: "mb-10 text-14"
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('booking.accommodation.packageContent.allInclusiveReassuranceSportAndActivitiesDetailedDescription')),
    trackingData: {
      event: _tracking_constants__WEBPACK_IMPORTED_MODULE_27__[/* TRACK_EVENT_NAMES */ "F"].CLICK_RECEIPT_TICKET,
      payload: {
        detail_click: 'price_details_receipt_activities'
      }
    }
  }, {
    iconName: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_11__[/* ICONS */ "a"].ENTERTAINMENT,
    dataTestId: 'shows-button',
    topLeft: Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('booking.accommodation.packageContent.allInclusiveReassurance.entertainment.message'),
    topRight: Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('common.included'),
    children: __jsx("p", {
      className: "mb-10 text-14"
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('booking.accommodation.packageContent.allInclusiveReassuranceEntertainmentDetailedDescription')),
    trackingData: {
      event: _tracking_constants__WEBPACK_IMPORTED_MODULE_27__[/* TRACK_EVENT_NAMES */ "F"].CLICK_RECEIPT_TICKET,
      payload: {
        detail_click: 'price_details_receipt_shows'
      }
    }
  }, {
    iconName: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_11__[/* ICONS */ "a"].WIFI,
    topLeft: Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('booking.accommodation.packageContent.allInclusiveReassurance.wifiAccess.message'),
    topRight: Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('common.included')
  }, {
    isNull: !Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* getKeyValue */ "d"])(Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('booking.priceDetails.packagePrice.displayMedicalInsurance')),
    iconName: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_11__[/* ICONS */ "a"].INSURANCE,
    topLeft: Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('booking.priceDetails.packagePrice.medicalInsurance'),
    topRight: Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('common.included')
  }, {
    isNull: !promoCode,
    component: promoCode
  }, {
    isNull: !insurance,
    component: insurance
  }, {
    dataTestId: 'fees-button',
    isNull: !(taxes === null || taxes === void 0 ? void 0 : taxes.SUBSCRIPTION),
    topLeft: Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('booking.priceDetails.packagePrice.fees.annualMembershipFeesLabel'),
    topRight: __jsx("p", {
      className: "font-bold text-sienna"
    }, "+ ", taxes === null || taxes === void 0 ? void 0 : taxes.SUBSCRIPTION),
    children: __jsx("p", {
      className: "text-14"
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('booking.priceDetails.packagePrice.annualFeesInformation')),
    trackingData: {
      event: _tracking_constants__WEBPACK_IMPORTED_MODULE_27__[/* TRACK_EVENT_NAMES */ "F"].CLICK_RECEIPT_TICKET,
      payload: {
        detail_click: 'price_details_receipt_fees'
      }
    }
  }, {
    dataTestId: 'taxes-button',
    isNull: !(taxes === null || taxes === void 0 ? void 0 : taxes.PORT_TAXES),
    topLeft: Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('booking.priceDetails.packagePrice.fees.portTaxesLabel'),
    topRight: __jsx("p", {
      className: "font-bold text-sienna"
    }, "+ ", taxes === null || taxes === void 0 ? void 0 : taxes.PORT_TAXES),
    children: __jsx("p", {
      className: "text-14"
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('booking.priceDetails.packagePrice.fees.portTaxesDescription')),
    trackingData: {
      event: _tracking_constants__WEBPACK_IMPORTED_MODULE_27__[/* TRACK_EVENT_NAMES */ "F"].CLICK_RECEIPT_TICKET,
      payload: {
        detail_click: 'price_details_receipt_taxes'
      }
    }
  }, {
    isNull: insuranceValue() === null,
    topLeft: Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('booking.insurance.insuranceLabel'),
    topRight: __jsx("p", {
      className: "font-bold text-sienna"
    }, "+ ", insuranceValue())
  }, {
    dataTestId: 'touristic-taxes-button',
    isNull: !(taxes === null || taxes === void 0 ? void 0 : taxes.TOURISTIC_TAXES),
    topLeft: Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('booking.priceDetails.packagePrice.fees.touristicTaxesLabel'),
    topRight: __jsx("p", {
      className: "font-bold text-sienna"
    }, "+ ", taxes === null || taxes === void 0 ? void 0 : taxes.TOURISTIC_TAXES),
    children: __jsx("p", {
      className: "text-14"
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('booking.priceDetails.packagePrice.fees.touristicTaxesDescription')),
    trackingData: {
      event: _tracking_constants__WEBPACK_IMPORTED_MODULE_27__[/* TRACK_EVENT_NAMES */ "F"].CLICK_RECEIPT_TICKET,
      payload: {
        detail_click: 'price_details_receipt_touristic_taxes'
      }
    }
  }, {
    isLastItem: true,
    topLeft: __jsx("p", {
      className: "font-bold"
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('booking.priceDetails.packagePrice.totalPrice')),
    topRight: __jsx("p", {
      className: "text-18 font-bold"
    }, totalPrice),
    bottomRight: selectedRate,
    bottomLeft: Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* getKeyValue */ "d"])(Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('booking.priceDetails.packagePrice.fees.displayTaxesAndFeesIncludedMention')) && __jsx("p", {
      className: "font-normal"
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('booking.priceDetails.packagePrice.fees.taxesAndFeesIncludedLabel')),
    trackingData: {
      event: _tracking_constants__WEBPACK_IMPORTED_MODULE_27__[/* TRACK_EVENT_NAMES */ "F"].CLICK_RECEIPT_TICKET,
      payload: {
        detail_click: 'price_details_receipt_touristic_taxes'
      }
    }
  }];

  if (!showPriceDetailLines) {
    return [priceDetail.pop()];
  }

  return priceDetail;
};
var hasPersonRentedAnUpsell = function hasPersonRentedAnUpsell(upsells, personId) {
  return upsells.some(function (upsell) {
    return upsell.pricingInfo.attendees.some(function (attendee) {
      return attendee.id === personId && attendee.rentedAmount.value !== 0;
    });
  });
};
var getSummaryViewLinesByProposal = function getSummaryViewLinesByProposal(_ref3) {
  var _selectedProposal$add, _selectedProposal$add2, _selectedProposal$add3, _selectedProposal$add4, _selectedProposal$add5, _selectedProposal$add6, _selectedProposal$add7, _selectedAccommodatio;

  var accommodationSummary = _ref3.accommodationSummary,
      locale = _ref3.locale,
      selectedProposal = _ref3.selectedProposal,
      isJoyViewOrUrbanOasisAllInclusive = _ref3.isJoyViewOrUrbanOasisAllInclusive,
      isUrbanOasisFoodAndBeverage = _ref3.isUrbanOasisFoodAndBeverage;
  var accommodations = selectedProposal.accommodations,
      attendees = selectedProposal.attendees,
      duration = selectedProposal.duration,
      price = selectedProposal.price;
  var quantityOfAdults = attendees.adults.length;
  var quantityOfChildren = attendees.children.length;
  var childcares = selectedProposal === null || selectedProposal === void 0 ? void 0 : (_selectedProposal$add = selectedProposal.additionalServices) === null || _selectedProposal$add === void 0 ? void 0 : _selectedProposal$add.childcares;
  var activities = selectedProposal === null || selectedProposal === void 0 ? void 0 : (_selectedProposal$add2 = selectedProposal.additionalServices) === null || _selectedProposal$add2 === void 0 ? void 0 : (_selectedProposal$add3 = _selectedProposal$add2.activities) === null || _selectedProposal$add3 === void 0 ? void 0 : _selectedProposal$add3.filter(function (obj) {
    return obj.pricingInfo.isPartiallyRented === true;
  });
  var equipments = selectedProposal === null || selectedProposal === void 0 ? void 0 : (_selectedProposal$add4 = selectedProposal.additionalServices) === null || _selectedProposal$add4 === void 0 ? void 0 : (_selectedProposal$add5 = _selectedProposal$add4.rentals) === null || _selectedProposal$add5 === void 0 ? void 0 : _selectedProposal$add5.filter(function (rental) {
    return rental.pricingInfo.isPartiallyRented === true;
  });
  var transferUpsell = selectedProposal === null || selectedProposal === void 0 ? void 0 : (_selectedProposal$add6 = selectedProposal.additionalServices) === null || _selectedProposal$add6 === void 0 ? void 0 : (_selectedProposal$add7 = _selectedProposal$add6.transfers) === null || _selectedProposal$add7 === void 0 ? void 0 : _selectedProposal$add7.filter(function (obj) {
    return obj.pricingInfo.isFullyRented === true;
  });
  var sumPriceAllActivities = activities.map(function (equipment) {
    var _equipment$pricingInf, _equipment$pricingInf2;

    return (_equipment$pricingInf = equipment.pricingInfo) === null || _equipment$pricingInf === void 0 ? void 0 : (_equipment$pricingInf2 = _equipment$pricingInf.rentedAmountWithoutDiscount) === null || _equipment$pricingInf2 === void 0 ? void 0 : _equipment$pricingInf2.value;
  }).reduce(function (acc, currentValue) {
    return acc + currentValue;
  }, 0) + equipments.map(function (equipment) {
    var _equipment$pricingInf3, _equipment$pricingInf4;

    return (_equipment$pricingInf3 = equipment.pricingInfo) === null || _equipment$pricingInf3 === void 0 ? void 0 : (_equipment$pricingInf4 = _equipment$pricingInf3.rentedAmountWithoutDiscount) === null || _equipment$pricingInf4 === void 0 ? void 0 : _equipment$pricingInf4.value;
  }).reduce(function (acc, currentValue) {
    return acc + currentValue;
  }, 0);
  var hasTransports = selectedProposal.transports;
  var hasActivities = activities.length > 0;
  var hasEquipments = equipments.length > 0;
  var childcaresUpsell = childcares.filter(function (childcare) {
    return childcare.pricingInfo.isPartiallyRented === true;
  });
  var hasTransfer = transferUpsell.length > 0 || hasTransports;
  var accommodationsIds = accommodations.map(function (accommodation) {
    return accommodation.id;
  });
  var selectedAccommodations = accommodations.filter(function (acc) {
    return accommodationsIds.includes(acc.id);
  });
  var bedroomsNames = selectedAccommodations && selectedAccommodations.length > 1 ? selectedAccommodations && selectedAccommodations.map(function (el) {
    return el.label;
  }).join(" ".concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('common.and'), " ")) : (_selectedAccommodatio = selectedAccommodations[0]) === null || _selectedAccommodatio === void 0 ? void 0 : _selectedAccommodatio.label;
  var transferLabels = Object(_components_widgets_stay_summary_ticket_StaySummaryTicket_utils__WEBPACK_IMPORTED_MODULE_15__[/* getTransferLabels */ "b"])(selectedProposal);
  var nightsDuration = duration > 1 ? Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('booking.confirmation.nights', {
    duration: duration
  }) : "".concat(duration, " ").concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('booking.confirmation.night'));
  var rooms = Object(_utils_accommodation_accommodation_utils__WEBPACK_IMPORTED_MODULE_22__[/* roomQuantity */ "b"])(accommodations)[0] > 1 || selectedAccommodations.length > 1 ? Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('booking.confirmation.rooms') : Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('booking.confirmation.room');

  var childcareIncludedOrOnDemand = childcaresUpsell.length > 0 && __jsx(_components_widgets_stay_summary_ticket_StaySummaryTicketUpsell__WEBPACK_IMPORTED_MODULE_14__[/* StaySummaryTicketUpsell */ "a"], {
    transferUpsell: transferUpsell,
    childcares: childcares,
    price: price
  });

  var lines = [{
    iconName: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_11__[/* ICONS */ "a"].DATE,
    topLeft: Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('booking.common.dates'),
    bottomLeft: "".concat(Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_17__[/* getFormattedArrivalDate */ "f"])(selectedProposal).slice(0, 6), " -\n            ").concat(Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_17__[/* getFormattedDepartureDate */ "g"])(selectedProposal).slice(0, 6)),
    bottomRight: nightsDuration,
    isFirstItem: true
  }, {
    iconName: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_11__[/* ICONS */ "a"].PEOPLE_DOUBLE,
    topLeft: Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('booking.common.participants'),
    bottomLeft: Object(_utils_participants_participants_utils__WEBPACK_IMPORTED_MODULE_23__[/* getNumberOfAdultsAndChildren */ "b"])(quantityOfChildren, quantityOfAdults)
  }, {
    iconName: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_11__[/* ICONS */ "a"].ACCOMODATIONS,
    dataTestId: 'accommodation-button',
    bottomLeft: bedroomsNames,
    children: accommodationSummary,
    labelGA: 'receipt_room',
    topLeft: rooms,
    trackingData: {
      event: _tracking_constants__WEBPACK_IMPORTED_MODULE_27__[/* TRACK_EVENT_NAMES */ "F"].CLICK_RECEIPT_TICKET,
      payload: {
        detail_click: 'receipt_room'
      }
    }
  }, {
    iconName: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_11__[/* ICONS */ "a"].TRANSFER,
    isNull: !hasTransfer,
    bottomLeft: transferLabels,
    labelGA: 'receipt_transfert',
    topLeft: Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('common.transport.transfer.withTransferLabel'),
    topRight: transferUpsell.length > 0 && __jsx(_components_widgets_stay_summary_ticket_StaySummaryTicketUpsell__WEBPACK_IMPORTED_MODULE_14__[/* StaySummaryTicketUpsell */ "a"], {
      transferUpsell: transferUpsell,
      price: price
    }),
    trackingData: {
      event: _tracking_constants__WEBPACK_IMPORTED_MODULE_27__[/* TRACK_EVENT_NAMES */ "F"].CLICK_RECEIPT_TICKET,
      payload: {
        detail_click: 'receipt_transfert'
      }
    }
  }, {
    iconName: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_11__[/* ICONS */ "a"].TRANSPORT,
    dataTestId: 'transport-button',
    isNull: !hasTransports,
    bottomLeft: Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('booking.confirmation.inboundAndOutbound'),
    topLeft: Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('common.transport.withTransportLabel'),
    labelGA: 'receipt_transport',
    children: __jsx("div", {
      className: "mb-15"
    }, __jsx(_components_widgets_be_transport_details_BeTransportDetails__WEBPACK_IMPORTED_MODULE_12__[/* BeTransportDetails */ "a"], {
      transport: selectedProposal === null || selectedProposal === void 0 ? void 0 : selectedProposal.transports,
      withoutTitle: true
    })),
    trackingData: {
      event: _tracking_constants__WEBPACK_IMPORTED_MODULE_27__[/* TRACK_EVENT_NAMES */ "F"].CLICK_RECEIPT_TICKET,
      payload: {
        detail_click: 'receipt_transport'
      }
    }
  }, {
    iconName: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_11__[/* ICONS */ "a"].KIDS,
    isNull: childcaresUpsell.length === 0,
    bottomLeft: Object(_utils_childcare_childcare_utils__WEBPACK_IMPORTED_MODULE_21__[/* displayChildcaresNames */ "c"])(selectedProposal, childcaresUpsell),
    children: __jsx(_components_widgets_childcare_summary_ChildcareSummary__WEBPACK_IMPORTED_MODULE_18__[/* ChildcareSummary */ "a"], {
      childcares: childcaresUpsell,
      proposal: selectedProposal
    }),
    dataTestId: 'childcare-button',
    topLeft: Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('common.price.childcareLabel'),
    topRight: childcareIncludedOrOnDemand,
    trackingData: {
      event: _tracking_constants__WEBPACK_IMPORTED_MODULE_27__[/* TRACK_EVENT_NAMES */ "F"].CLICK_RECEIPT_TICKET,
      payload: {
        detail_click: 'receipt_childcare'
      }
    }
  }, {
    iconName: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_11__[/* ICONS */ "a"].TENNIS,
    isNull: !hasActivities && !hasEquipments,
    bottomLeft: Object(_utils_activity_activity_utils__WEBPACK_IMPORTED_MODULE_20__[/* displayActivitiesAndEquipmentsNames */ "a"])(hasActivities, hasEquipments, activities, equipments),
    bottomRight: __jsx("p", {
      className: "text-orange"
    }, '+ ' + Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_19__[/* formatAmountForLocale */ "b"])(sumPriceAllActivities, locale, undefined, {
      precision: 2
    })),
    children: __jsx("div", {
      className: "mt-30"
    }, __jsx(_components_widgets_stay_summary_ticket_GetParticipantsActivities__WEBPACK_IMPORTED_MODULE_13__[/* GetParticipantsActivities */ "a"], {
      proposal: selectedProposal,
      participants: selectedProposal.attendees.adults,
      isChild: false
    }), __jsx(_components_widgets_stay_summary_ticket_GetParticipantsActivities__WEBPACK_IMPORTED_MODULE_13__[/* GetParticipantsActivities */ "a"], {
      proposal: selectedProposal,
      participants: selectedProposal.attendees.children,
      isChild: true
    })),
    dataTestId: 'activities-button',
    topLeft: Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('common.activities.label'),
    topRight: __jsx("p", {
      className: "text-14 font-bold text-orange"
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('booking.confirmation.onDemand')),
    trackingData: {
      event: _tracking_constants__WEBPACK_IMPORTED_MODULE_27__[/* TRACK_EVENT_NAMES */ "F"].CLICK_RECEIPT_TICKET,
      payload: {
        detail_click: 'receipt_activities'
      }
    }
  }, {
    component: isJoyViewOrUrbanOasisAllInclusive && __jsx("div", {
      className: "flex items-center justify-between rounded-12 border-1 border-grey bg-pearl p-15",
      "data-testid": "joyview-frame"
    }, __jsx("div", {
      className: "flex items-center gap-20"
    }, __jsx("div", null, __jsx(_components_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_26__[/* Icon */ "a"], {
      className: "text-black",
      name: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_11__[/* ICONS */ "a"].ALL_INCLUSIVE,
      width: "1.875rem"
    })), __jsx("p", {
      className: "font-bold"
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('booking.services.PAIBlockTitle'))), __jsx("p", {
      className: "font-bold text-sienna"
    }, selectedProposal.alternativePackages && selectedProposal.alternativePackages[0].upsellPrice)),
    isNull: !isJoyViewOrUrbanOasisAllInclusive
  }, {
    component: isUrbanOasisFoodAndBeverage && __jsx("div", {
      className: "flex items-center justify-between rounded-12 border-1 border-grey bg-pearl p-15",
      "data-testid": "joyview-frame"
    }, __jsx("div", {
      className: "flex items-center gap-20"
    }, __jsx("div", null, __jsx(_components_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_26__[/* Icon */ "a"], {
      className: "text-black",
      name: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_11__[/* ICONS */ "a"].DISHES,
      width: "1.875rem"
    })), __jsx("p", {
      className: "font-bold"
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('booking.services.FFBBlockTitle'))), __jsx("p", {
      className: "font-bold text-sienna"
    }, selectedProposal.alternativePackages && selectedProposal.alternativePackages[0].upsellPrice)),
    isNull: !isUrbanOasisFoodAndBeverage
  }];
  return lines;
};

/***/ }),

/***/ "a2Xc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BeTransportDetails; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("kiXb");
/* harmony import */ var _transport_details_transportUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z8xc");
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("1JJ2");
/* harmony import */ var _frameworks_notification_Notification__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("VO9w");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("SPKZ");
/* harmony import */ var _frameworks_notification_SimpleNotification__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("qOTJ");
/* harmony import */ var _TransportTicket__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("k52x");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;








function BeTransportDetails(_ref) {
  var isComparator = _ref.isComparator,
      isTransportRecommended = _ref.isTransportRecommended,
      withoutTitle = _ref.withoutTitle,
      transport = _ref.transport;

  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_3__[/* useResponsive */ "b"])(),
      isTablet = _useResponsive.isTablet;

  var hasSchedules = Object(_transport_details_transportUtils__WEBPACK_IMPORTED_MODULE_2__[/* tripsHaveSchedules */ "q"])(transport === null || transport === void 0 ? void 0 : transport.inbound, transport === null || transport === void 0 ? void 0 : transport.outbound);
  var theme = isComparator || !isTablet ? 'mobile' : 'desktop';

  if (!(transport === null || transport === void 0 ? void 0 : transport.inbound) && !(transport === null || transport === void 0 ? void 0 : transport.outbound)) {
    return __jsx(_frameworks_notification_Notification__WEBPACK_IMPORTED_MODULE_4__[/* Notification */ "a"], {
      className: "text-red",
      text: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('common.transport.errors.displayErrorDescription')
    });
  }

  return __jsx("div", {
    "data-testid": "BeTransportDetails"
  }, !withoutTitle && __jsx("div", {
    className: "mb-20 text-28 font-bold"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.transport.title')), !hasSchedules && __jsx(_frameworks_notification_SimpleNotification__WEBPACK_IMPORTED_MODULE_6__[/* SimpleNotification */ "a"], {
    id: "TransportCharterInformations",
    title: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('common.transport.warnings.reassuranceTitle'),
    content: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('common.transport.warnings.reassuranceMessageNoInformation'),
    className: "mb-20",
    iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].LIGHTBULB
  }), __jsx(_TransportTicket__WEBPACK_IMPORTED_MODULE_7__[/* TransportTicket */ "a"], {
    theme: theme,
    isTransportRecommended: isTransportRecommended,
    transport: transport,
    isSelected: true
  }));
}

/***/ }),

/***/ "g5cf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccommodationSummary; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _frameworks_image_slideshow_ImageSlideShow__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("DQFb");
/* harmony import */ var _accommodations_BookingAccommodationsUtils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("cb6o");
/* harmony import */ var _accommodation_room_infos_AccommodationRoomInfos__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("pciL");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("kiXb");







var __jsx = react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement;





var AccommodationSummary = function AccommodationSummary(_ref) {
  var accommodations = _ref.accommodations,
      resort = _ref.resort,
      roomQuantity = _ref.roomQuantity;
  var accommodationsIds = accommodations.map(function (accommodation) {
    return accommodation.id;
  });
  var selectedAccommodations = resort.accommodations.filter(function (acc) {
    return accommodationsIds.includes(acc.id);
  });
  return selectedAccommodations.map(function (selectedAccommodation) {
    var _selectedAccommodatio;

    var babyCount = ((_selectedAccommodatio = selectedAccommodation.equipments) === null || _selectedAccommodatio === void 0 ? void 0 : _selectedAccommodatio.some(function (equipment) {
      return equipment.id === 'MAT_baby_bed';
    })) ? 1 : selectedAccommodation.babyCount;
    var surfaceItem = Object(_accommodations_BookingAccommodationsUtils__WEBPACK_IMPORTED_MODULE_9__[/* getSurfaceIconItem */ "f"])(selectedAccommodation.roomType, resort, selectedAccommodation.surface);
    var babyBedItem = Object(_accommodations_BookingAccommodationsUtils__WEBPACK_IMPORTED_MODULE_9__[/* getBabyBedIconItem */ "c"])(babyCount);
    var capacityItem = Object(_accommodations_BookingAccommodationsUtils__WEBPACK_IMPORTED_MODULE_9__[/* getCapacityIconItem */ "d"])(selectedAccommodation.maxCapacity);
    var outsideFacilityItem = Object(_accommodations_BookingAccommodationsUtils__WEBPACK_IMPORTED_MODULE_9__[/* getOutsideFacilitiesIconItem */ "e"])(selectedAccommodation.outsideFacilities);
    var viewItem = Object(_accommodations_BookingAccommodationsUtils__WEBPACK_IMPORTED_MODULE_9__[/* getViewIconItem */ "g"])(selectedAccommodation.view);
    var items = Object(_accommodations_BookingAccommodationsUtils__WEBPACK_IMPORTED_MODULE_9__[/* aggregateIconList */ "a"])(selectedAccommodation.strengths, surfaceItem, capacityItem, outsideFacilityItem, viewItem, babyBedItem);
    return __jsx("div", {
      key: selectedAccommodation.id
    }, __jsx("div", {
      className: "flex flex-col"
    }, __jsx("div", {
      className: "mb-10 mt-30 sm:flex sm:flex-row sm:flex-wrap"
    }, __jsx("div", {
      className: "relative sm:w-1/2 sm:pe-10 md:w-2/5"
    }, __jsx(_frameworks_image_slideshow_ImageSlideShow__WEBPACK_IMPORTED_MODULE_8__[/* ImageSlideShow */ "a"], {
      className: "flex flex-col items-center justify-center overflow-hidden rounded-12",
      hasInfiniteScroll: true,
      hasLazyLoading: true,
      media: selectedAccommodation.media.photos.map(function (photo) {
        return {
          src: photo.url
        };
      })
    })), __jsx("div", {
      className: "flex flex-col pb-10 sm:w-1/2 sm:justify-between sm:pb-0 sm:ps-10 md:w-3/5"
    }, __jsx("div", {
      className: "flex justify-between"
    }, __jsx("p", {
      className: "text-blue mb-10 mt-10 font-brand text-18"
    }, selectedAccommodation.label), roomQuantity[0] > 1 && __jsx("p", {
      className: "text-blue mb-10 mt-0 font-brand text-20"
    }, "x", roomQuantity)), __jsx("p", {
      className: "mb-10 mt-0 text-14"
    }, selectedAccommodation.description), __jsx("p", {
      className: "m-0 text-14"
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_11__[/* t */ "h"])('common.details'), ":"), __jsx(_accommodation_room_infos_AccommodationRoomInfos__WEBPACK_IMPORTED_MODULE_10__[/* AccommodationRoomInfos */ "a"], {
      theme: "column",
      items: items,
      isInMoreRoomLayer: false,
      isAccommodationSummary: true
    })))), selectedAccommodations.length > 1 && selectedAccommodation !== selectedAccommodations[selectedAccommodations.length - 1] && __jsx("div", {
      className: "relative flex items-center py-40"
    }, __jsx("div", {
      className: "grow border-t border-mediumGrey"
    }), __jsx("span", {
      className: "mx-4 shrink px-20 font-brand text-18 text-mediumGrey"
    }, "&"), __jsx("div", {
      className: "grow border-t border-mediumGrey"
    })));
  });
};

/***/ }),

/***/ "gAE7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ GetParticipantsActivities_GetParticipantsActivities; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// CONCATENATED MODULE: ./src/client/components/widgets/upsells-block/UpsellsBlock.jsx






var __jsx = react_default.a.createElement;






var UpsellsBlock_displayUpsellDates = function displayUpsellDates(upsell) {
  var addedUpsell = upsell.pricingInfo.attendees.filter(function (el) {
    return el.rentedAmount.value !== 0;
  });

  var _addedUpsell$map = addedUpsell.map(function (_ref) {
    var schedules = _ref.schedules;
    return schedules.filter(function (_ref2) {
      var isPartiallyRented = _ref2.isPartiallyRented;
      return isPartiallyRented;
    }).map(function (schedule) {
      return {
        startDate: schedule.startDate,
        endDate: schedule.endDate
      };
    });
  }),
      _addedUpsell$map2 = Object(slicedToArray["a" /* default */])(_addedUpsell$map, 1),
      _addedUpsell$map2$ = Object(slicedToArray["a" /* default */])(_addedUpsell$map2[0], 1),
      _addedUpsell$map2$$ = _addedUpsell$map2$[0],
      startDate = _addedUpsell$map2$$.startDate,
      endDate = _addedUpsell$map2$$.endDate;

  var start = moment_default()(startDate).format('L');
  var end = moment_default()(endDate).format('L');

  if (start === end) {
    return start;
  }

  return Object(i18n["h" /* t */])('booking.confirmation.dateToBeSelected', {
    activityStartDate: start,
    activityEndDate: end
  });
};

var UpsellsBlock_UpsellsBlock = function UpsellsBlock(_ref3) {
  var person = _ref3.person,
      upsells = _ref3.upsells;
  return upsells.filter(function (upsell) {
    return upsell.pricingInfo.attendees.find(function (attendee) {
      return attendee.id === person.id && attendee.rentedAmount.value !== 0;
    });
  }).map(function (upsell) {
    var _upsell$pricingInfo$a, _upsell$pricingInfo$a2;

    return __jsx("div", {
      key: upsell.productInfo.id,
      className: "bg-white mb-20 p-20 rounded-12 shadow-sm space-y-10 text-14"
    }, __jsx("div", {
      className: "flex font-bold gap-10 justify-between text-16 w-full"
    }, __jsx("p", {
      className: "font-brand w-1/2"
    }, upsell.productInfo.label), __jsx("p", null, (_upsell$pricingInfo$a = upsell.pricingInfo.attendees.find(function (attendee) {
      return attendee.id === person.id;
    })) === null || _upsell$pricingInfo$a === void 0 ? void 0 : (_upsell$pricingInfo$a2 = _upsell$pricingInfo$a.rentedAmountWithoutDiscount) === null || _upsell$pricingInfo$a2 === void 0 ? void 0 : _upsell$pricingInfo$a2.formattedValue)), upsell.productInfo.description && __jsx("p", {
      className: "flex gap-10 w-3/4"
    }, __jsx(Icon["a" /* Icon */], {
      className: "shrink-0 mt-2",
      name: icons["a" /* ICONS */].DURATION,
      width: "1.1rem"
    }), upsell.productInfo.description), __jsx("p", {
      className: "flex gap-10 w-3/4"
    }, __jsx(Icon["a" /* Icon */], {
      className: "shrink-0 mt-2",
      name: icons["a" /* ICONS */].DATE,
      width: "1.1rem"
    }), UpsellsBlock_displayUpsellDates(upsell)));
  });
};
// EXTERNAL MODULE: ./src/client/views/booking/summary/SummaryView.utils.js
var SummaryView_utils = __webpack_require__("X3Cs");

// CONCATENATED MODULE: ./src/client/components/widgets/stay-summary-ticket/GetParticipantsActivities.jsx



var GetParticipantsActivities_jsx = react_default.a.createElement;




var GetParticipantsActivities_GetParticipantsActivities = function GetParticipantsActivities(_ref) {
  var participants = _ref.participants,
      proposal = _ref.proposal,
      isChild = _ref.isChild;
  return participants.map(function (person, index) {
    return GetParticipantsActivities_jsx(react_default.a.Fragment, {
      key: person.id
    }, Object(SummaryView_utils["d" /* hasPersonRentedAnUpsell */])([].concat(Object(toConsumableArray["a" /* default */])(proposal.additionalServices.activities), Object(toConsumableArray["a" /* default */])(proposal.additionalServices.rentals)), person.id) && GetParticipantsActivities_jsx("p", {
      className: "mt-0 mb-10 text-20 font-bold"
    }, isChild ? "".concat(Object(i18n["h" /* t */])('booking.confirmation.child'), " ").concat(index + 1) : "".concat(Object(i18n["h" /* t */])('booking.confirmation.adult'), " ").concat(index + 1)), GetParticipantsActivities_jsx(UpsellsBlock_UpsellsBlock, {
      person: person,
      upsells: proposal.additionalServices.activities
    }), GetParticipantsActivities_jsx(UpsellsBlock_UpsellsBlock, {
      person: person,
      upsells: proposal.additionalServices.rentals
    }));
  });
};

/***/ }),

/***/ "hA0C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductLogo_ProductLogo; });

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/widgets/product-logo/ProductLogo.theme.js

var themes = {
  "default": function _default(_ref) {
    var isExclusiveCollection = _ref.isExclusiveCollection;
    return {
      thRoot: 'text-center',
      thIcon: Object(classnames_utils["a" /* classnames */])('mb-15', {
        'rounded-full bg-lightSand p-15 text-black': !isExclusiveCollection
      }, {
        'rounded-12 border-5 border-ultramarine p-10 text-ultramarine': isExclusiveCollection
      }),
      thIconWidth: '6.25rem',
      thIsNotSquare: false,
      thProductInfo: 'flex flex-col-reverse text-initial',
      thProductCountry: 'font-bold text-14 text-sienna truncate w-full',
      thProductName: 'font-bold leading-tight text-18'
    };
  },
  calendar: function calendar() {
    return {
      thRoot: 'font-brand leading-tight text-black text-center text-16',
      thIconWidth: '5rem',
      thIsNotSquare: true
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-logo/ProductLogo.jsx
var __jsx = react_default.a.createElement;




var ProductLogo_ProductLogo = function ProductLogo(_ref) {
  var className = _ref.className,
      isExclusiveCollection = _ref.isExclusiveCollection,
      iconName = _ref.iconName,
      productCountry = _ref.productCountry,
      productName = _ref.productName,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _themes$theme = themes[theme]({
    isExclusiveCollection: isExclusiveCollection
  }),
      thIcon = _themes$theme.thIcon,
      thIconWidth = _themes$theme.thIconWidth,
      thRoot = _themes$theme.thRoot,
      thIsNotSquare = _themes$theme.thIsNotSquare,
      thProductInfo = _themes$theme.thProductInfo,
      thProductName = _themes$theme.thProductName,
      thProductCountry = _themes$theme.thProductCountry;

  return __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className)
  }, __jsx(Icon["a" /* Icon */], {
    alt: productName,
    className: thIcon,
    isNotSquare: thIsNotSquare,
    name: iconName,
    width: thIconWidth
  }), __jsx("div", {
    className: thProductInfo
  }, productName && __jsx("p", {
    className: thProductName,
    "data-testid": "product-logo-name"
  }, productName), productCountry && __jsx("p", {
    className: thProductCountry,
    "data-testid": "product-logo-country"
  }, productCountry)));
};

/***/ }),

/***/ "k52x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TransportTicket; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/widgets/transport-details/transportUtils.js
var transportUtils = __webpack_require__("z8xc");

// EXTERNAL MODULE: ./src/client/components/widgets/be-transport-details/BeTransportDetails.themes.js
var BeTransportDetails_themes = __webpack_require__("vvV4");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/widgets/be-transport-details/transport-details/TransportDetails.jsx + 12 modules
var TransportDetails = __webpack_require__("RTMn");

// EXTERNAL MODULE: ./src/client/components/frameworks/tag/Tag.jsx + 1 modules
var Tag = __webpack_require__("N5WC");

// EXTERNAL MODULE: ./src/client/components/frameworks/notification/SimpleNotification.jsx
var SimpleNotification = __webpack_require__("qOTJ");

// EXTERNAL MODULE: ./src/hooks/use-feature-flip/useFeatureFlip.js
var useFeatureFlip = __webpack_require__("xu+1");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/utils/transport/carbonEmissionsUtils.js
var carbonEmissionsUtils = __webpack_require__("YYp0");

// CONCATENATED MODULE: ./src/client/components/widgets/be-transport-details/TransportsDetailsCarbonEmissions.jsx


var __jsx = react_default.a.createElement;






function TransportsDetailsCarbonEmissions(_ref) {
  var inbound = _ref.inbound,
      outbound = _ref.outbound;
  var isCarbonEmissionsEnabled = Object(useFeatureFlip["a" /* useFeatureFlip */])('booking.carbonEmissions'); // Calculate total emissions for both inbound and outbound

  var inboundSections = (inbound === null || inbound === void 0 ? void 0 : inbound.travelSections) || [];
  var outboundSections = (outbound === null || outbound === void 0 ? void 0 : outbound.travelSections) || [];
  var allSections = [].concat(Object(toConsumableArray["a" /* default */])(inboundSections), Object(toConsumableArray["a" /* default */])(outboundSections));
  var totalEmissions = Object(carbonEmissionsUtils["c" /* calculateTotalEmissions */])(allSections);
  var totalEmissionsLabel = totalEmissions && Object(i18n["h" /* t */])('common.transport.carbonEmissionTotal', {
    total: totalEmissions
  });
  var averageEmissions = Object(carbonEmissionsUtils["a" /* calculateAverageEmissions */])(allSections);
  var percentageDiff = Object(carbonEmissionsUtils["b" /* calculatePercentageDifference */])(totalEmissions, averageEmissions); // Build the carbon emission message based on comparison

  var carbonEmissionMessage = null;

  if (isCarbonEmissionsEnabled && allSections.length > 0 && totalEmissions != null) {
    // Determine which message to display based on percentage difference
    if (percentageDiff == null || percentageDiff.percentage === 0) {
      // Emissions equal to average - use carbonEmissionMessage (no percentage)
      carbonEmissionMessage = Object(i18n["h" /* t */])('common.transport.carbonEmissionMessage');
    } else if (percentageDiff.isLess) {
      // Emissions less than average - use carbonEmissionLessLabel
      carbonEmissionMessage = Object(i18n["h" /* t */])('common.transport.carbonEmissionLessLabel', {
        percentage: "".concat(percentageDiff.percentage, "%")
      });
    } else {
      // Emissions more than average - use carbonEmissionMoreLabel
      carbonEmissionMessage = Object(i18n["h" /* t */])('common.transport.carbonEmissionMoreLabel', {
        percentage: "".concat(percentageDiff.percentage, "%")
      });
    }
  }

  if (!isCarbonEmissionsEnabled || !carbonEmissionMessage) {
    return null;
  }

  return __jsx("div", {
    className: "px-20"
  }, __jsx(SimpleNotification["a" /* SimpleNotification */], {
    id: "TransportCarbonEmissionInformations",
    content: "".concat(totalEmissionsLabel || '', " ").concat(carbonEmissionMessage),
    linkUrl: Object(i18n["h" /* t */])('common.transport.carbonEmissionLearnMoreUrl'),
    linkLabel: Object(i18n["h" /* t */])('common.transport.carbonEmissionLearnMore'),
    className: "mb-20",
    iconName: icons["a" /* ICONS */].UNION
  }));
}
// CONCATENATED MODULE: ./src/client/components/widgets/be-transport-details/TransportsDetails.jsx
var TransportsDetails_jsx = react_default.a.createElement;





function TransportsDetails(_ref) {
  var tag = _ref.tag,
      theme = _ref.theme,
      inbound = _ref.inbound,
      outbound = _ref.outbound,
      isTransportRecommended = _ref.isTransportRecommended,
      className = _ref.className;
  var baggageMoreInfoLabel = Object(i18n["h" /* t */])('common.transport.baggageMoreInfoLabel');
  var baggageLandingPageUrl = Object(i18n["h" /* t */])('common.transport.baggageLandingPageUrl');
  return TransportsDetails_jsx("div", {
    className: className,
    "data-testid": "TransportsDetails"
  }, TransportsDetails_jsx("div", {
    className: "h-full rounded-12 border-0 bg-white shadow-bottomDiffuse"
  }, TransportsDetails_jsx("div", {
    className: "h-fit pt-20"
  }, tag && TransportsDetails_jsx(Tag["a" /* Tag */], {
    className: "mx-20 mb-10"
  }, Object(i18n["h" /* t */])("booking.transport.sort.".concat(tag === 'cheapest' ? 'cheapestFlightLabel' : 'fastestFlightLabel'))), inbound && TransportsDetails_jsx(TransportDetails["a" /* TransportDetails */], {
    theme: theme,
    isInbound: true,
    transportDetail: inbound,
    isTransportRecommended: isTransportRecommended
  }), outbound && TransportsDetails_jsx(TransportDetails["a" /* TransportDetails */], {
    theme: theme,
    transportDetail: outbound,
    isTransportRecommended: isTransportRecommended
  })), baggageMoreInfoLabel && baggageLandingPageUrl && TransportsDetails_jsx("a", {
    rel: "noopener noreferrer",
    target: "_blank",
    href: baggageLandingPageUrl,
    className: "flex w-full justify-start px-20 pb-20 text-12 underline"
  }, Object(i18n["h" /* t */])('common.transport.baggageMoreInfoLabel')), TransportsDetails_jsx(TransportsDetailsCarbonEmissions, {
    inbound: inbound,
    outbound: outbound
  })));
}
// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/tooltip/Tooltip.jsx
var Tooltip = __webpack_require__("i3Ve");

// EXTERNAL MODULE: ./src/utils/transport/transportUtils.js
var transport_transportUtils = __webpack_require__("pdPG");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// CONCATENATED MODULE: ./src/client/components/widgets/be-transport-details/TransportSelection.jsx
var TransportSelection_jsx = react_default.a.createElement;










function TransportSelection(_ref) {
  var isPlane = _ref.isPlane,
      isSelected = _ref.isSelected,
      isTransportRecommended = _ref.isTransportRecommended,
      alternativeTransportPrice = _ref.alternativeTransportPrice,
      className = _ref.className,
      setSelectedTransport = _ref.setSelectedTransport;

  var _ref2 = alternativeTransportPrice || {},
      id = _ref2.id,
      totalDifferentialPrice = _ref2.totalDifferentialPrice;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  return TransportSelection_jsx("div", {
    className: className,
    "data-testid": "TransportSelection"
  }, TransportSelection_jsx("div", {
    className: "flex h-full w-full items-center justify-center rounded-12 bg-white shadow-bottomDiffuse"
  }, TransportSelection_jsx("div", {
    className: "flex w-full flex-col p-20 text-center"
  }, isSelected ? TransportSelection_jsx(react_default.a.Fragment, null, TransportSelection_jsx("div", {
    className: "flex justify-center"
  }, TransportSelection_jsx(Icon["a" /* Icon */], {
    className: "text-success",
    name: icons["a" /* ICONS */].CHECK_FILLED,
    width: "3rem"
  })), TransportSelection_jsx("p", {
    className: "text-24 font-bold leading-normal"
  }, Object(i18n["h" /* t */])('booking.transport.selectedFlight.selection')), TransportSelection_jsx("p", {
    className: "text-12 leading-1 text-mediumGrey"
  }, Object(i18n["h" /* t */])('booking.transport.selectedFlight.label'))) : TransportSelection_jsx(react_default.a.Fragment, null, totalDifferentialPrice && TransportSelection_jsx("p", {
    className: "text-20 font-semibold leading-normal"
  }, Object(transport_transportUtils["g" /* getTotalDifferentialPrice */])(totalDifferentialPrice)), TransportSelection_jsx("p", {
    className: "mb-20 text-12 leading-1 text-mediumGrey"
  }, Object(i18n["h" /* t */])('booking.transport.selectedFlight.priceDifference')), TransportSelection_jsx(Button["a" /* Button */], {
    className: "text-16 font-semibold",
    "data-selector": "transportSelection-cta",
    "data-testid": "TransportSelectionCta",
    onClick: function onClick() {
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_TRANSPORT_LAYER, {
        detail_click: 'validate_new_flight'
      });
      setSelectedTransport(id);
    },
    size: "medium"
  }, Object(i18n["h" /* t */])('booking.transport.planeTicket.CTASelectTransportLabel'))), isTransportRecommended && TransportSelection_jsx(Tooltip["a" /* Tooltip */], {
    modalProps: {
      closeLabel: Object(i18n["h" /* t */])('common.close'),
      size: 'small',
      children: null
    },
    renderTrigger: function renderTrigger(toggle) {
      return TransportSelection_jsx("button", {
        type: "button",
        onClick: toggle,
        className: "mt-20 flex items-center justify-center gap-4",
        "data-testid": "TransportSelectionRecommendedTooltip"
      }, TransportSelection_jsx("span", {
        className: "text-12 text-green underline"
      }, Object(i18n["h" /* t */])(isPlane ? 'booking.transport.transportRecommendationLabel' : 'booking.transport.otherTransportRecommendationLabel')), TransportSelection_jsx(Icon["a" /* Icon */], {
        className: "text-success",
        name: icons["a" /* ICONS */].CHECK,
        width: "1rem"
      }));
    }
  }, TransportSelection_jsx("div", {
    className: "p-20"
  }, TransportSelection_jsx(Text["a" /* Text */], {
    className: "mb-10 text-12",
    text: Object(i18n["h" /* t */])(isPlane ? 'booking.transport.transportRecommendationInformation' : 'booking.transport.otherTransportRecommendationInformation')
  }))))));
}
// CONCATENATED MODULE: ./src/client/components/widgets/be-transport-details/TransportTicket.jsx


var TransportTicket_jsx = react_default.a.createElement;






function TransportTicket(_ref) {
  var _transport$inbound, _transport$outbound;

  var tag = _ref.tag,
      theme = _ref.theme,
      isTransportRecommended = _ref.isTransportRecommended,
      isSelected = _ref.isSelected,
      transport = _ref.transport,
      alternativeTransportPrice = _ref.alternativeTransportPrice,
      _ref$setSelectedTrans = _ref.setSelectedTransport,
      setSelectedTransport = _ref$setSelectedTrans === void 0 ? function () {} : _ref$setSelectedTrans;
  var isPlane = Object(transportUtils["n" /* hasOnlyPlanes */])([].concat(Object(toConsumableArray["a" /* default */])((transport === null || transport === void 0 ? void 0 : (_transport$inbound = transport.inbound) === null || _transport$inbound === void 0 ? void 0 : _transport$inbound.travelSections) || []), Object(toConsumableArray["a" /* default */])((transport === null || transport === void 0 ? void 0 : (_transport$outbound = transport.outbound) === null || _transport$outbound === void 0 ? void 0 : _transport$outbound.travelSections) || [])));
  var _themes$theme = Object(BeTransportDetails_themes["a" /* themes */])()[theme],
      thWrapper = _themes$theme.thWrapper,
      thDashSeparator = _themes$theme.thDashSeparator;
  return TransportTicket_jsx("div", {
    "data-testid": "TransportTicket",
    className: thWrapper
  }, TransportTicket_jsx(TransportsDetails, {
    tag: tag,
    theme: theme,
    inbound: transport === null || transport === void 0 ? void 0 : transport.inbound,
    outbound: transport === null || transport === void 0 ? void 0 : transport.outbound,
    className: "grow"
  }), TransportTicket_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('border-greyBorder border border-b-0 border-r-0 border-dashed', thDashSeparator)
  }), TransportTicket_jsx(TransportSelection, {
    alternativeTransportPrice: alternativeTransportPrice,
    isTransportRecommended: isTransportRecommended,
    isPlane: isPlane,
    isSelected: isSelected,
    className: "min-w-240 grow-0",
    setSelectedTransport: setSelectedTransport
  }));
}

/***/ }),

/***/ "qOTJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SimpleNotification; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("C/y5");
/* harmony import */ var _badge_Badge__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("VHif");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;



var SimpleNotification = function SimpleNotification(_ref) {
  var id = _ref.id,
      title = _ref.title,
      content = _ref.content,
      iconName = _ref.iconName,
      className = _ref.className,
      linkUrl = _ref.linkUrl,
      linkLabel = _ref.linkLabel;
  return __jsx("div", {
    "data-testid": "SimpleNotification-".concat(id),
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])('h-full rounded-12 border-1 border-lightGrey bg-white p-20', className)
  }, __jsx("div", {
    "data-testid": "SimpleNotification-icon-".concat(id),
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])('flex gap-20', {
      'items-center': !title && !linkUrl,
      'items-start': title || linkUrl
    })
  }, __jsx(_badge_Badge__WEBPACK_IMPORTED_MODULE_2__[/* Badge */ "a"], {
    className: "size-48 border-lightSand bg-lightSand text-black",
    iconName: iconName,
    iconSize: "24px",
    variant: "pill"
  }), __jsx("div", {
    className: "text-start text-16 leading-normal"
  }, title && __jsx("p", {
    className: "mb-[8px] font-semibold"
  }, title), typeof content === 'string' ? __jsx("p", {
    className: "text-14"
  }, content) : content, linkUrl && linkLabel && __jsx("a", {
    href: linkUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "mt-8 inline-block text-14 font-semibold underline",
    "data-testid": "SimpleNotification-link-".concat(id)
  }, linkLabel))));
};

/***/ }),

/***/ "s2zd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTransferLabels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStaySummaryLinesByProposal; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("oL6k");
/* harmony import */ var _StaySummaryTicketUpsell__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("FkdH");
/* harmony import */ var _be_transport_details_BeTransportDetails__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("a2Xc");
/* harmony import */ var _utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("wz9x");
/* harmony import */ var _childcare_summary_ChildcareSummary__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("UY1v");
/* harmony import */ var _GetParticipantsActivities__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("gAE7");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_participants_participants_utils__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("WeO/");
/* harmony import */ var _utils_accommodation_accommodation_utils__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("Djgd");
/* harmony import */ var _utils_childcare_childcare_utils__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("erJz");
/* harmony import */ var _utils_activity_activity_utils__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("LALX");








var __jsx = react__WEBPACK_IMPORTED_MODULE_8___default.a.createElement;













var getTransferLabels = function getTransferLabels(proposal) {
  var _proposal$additionalS, _firstTransfer$pricin, _firstTransfer$pricin2, _firstTransfer$pricin3, _firstTransfer$pricin4;

  var firstTransfer = (_proposal$additionalS = proposal.additionalServices.transfers) === null || _proposal$additionalS === void 0 ? void 0 : _proposal$additionalS[0];

  var _ref = (firstTransfer === null || firstTransfer === void 0 ? void 0 : (_firstTransfer$pricin = firstTransfer.pricingInfo) === null || _firstTransfer$pricin === void 0 ? void 0 : (_firstTransfer$pricin2 = _firstTransfer$pricin.schedules) === null || _firstTransfer$pricin2 === void 0 ? void 0 : _firstTransfer$pricin2[0]) || {},
      firstTransferStartDate = _ref.startDate,
      firstTransferEndDate = _ref.endDate;

  var isOneWayTransfer = (firstTransfer === null || firstTransfer === void 0 ? void 0 : (_firstTransfer$pricin3 = firstTransfer.pricingInfo) === null || _firstTransfer$pricin3 === void 0 ? void 0 : (_firstTransfer$pricin4 = _firstTransfer$pricin3.schedules) === null || _firstTransfer$pricin4 === void 0 ? void 0 : _firstTransfer$pricin4.length) === 1;
  var outboundOnlyIncluded = isOneWayTransfer && firstTransferStartDate === proposal.departureDate;
  var inboundOnlyIncluded = isOneWayTransfer && firstTransferEndDate === proposal.arrivalDate;

  var transferLabels = __jsx(react__WEBPACK_IMPORTED_MODULE_8___default.a.Fragment, null, Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('common.transport.transfer.roundTrip'), __jsx("br", null), Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('common.transport.transfer.arrivalPoint'));

  if (outboundOnlyIncluded) {
    transferLabels = Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('common.transport.transfer.outboundOnlyIncluded');
  }

  if (inboundOnlyIncluded) {
    transferLabels = Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('common.transport.transfer.inboundOnlyIncluded');
  }

  return transferLabels;
};
var getStaySummaryLinesByProposal = function getStaySummaryLinesByProposal(_ref2) {
  var _proposal$additionalS2, _proposal$additionalS3, _proposal$additionalS4, _proposal$additionalS5, _proposal$additionalS6, _proposal$additionalS7, _proposal$additionalS8, _selectedAccommodatio;

  var accommodationSummary = _ref2.accommodationSummary,
      locale = _ref2.locale,
      proposal = _ref2.proposal;
  var accommodations = proposal.accommodations,
      attendees = proposal.attendees,
      duration = proposal.duration,
      price = proposal.price,
      resort = proposal.resort;
  var quantityOfAdults = attendees.adults.length;
  var quantityOfChildren = attendees.children.length;
  var childcares = proposal === null || proposal === void 0 ? void 0 : (_proposal$additionalS2 = proposal.additionalServices) === null || _proposal$additionalS2 === void 0 ? void 0 : _proposal$additionalS2.childcares;
  var childcaresUpsell = childcares.filter(function (childcare) {
    return childcare.pricingInfo.isPartiallyRented === true;
  });
  var activities = proposal === null || proposal === void 0 ? void 0 : (_proposal$additionalS3 = proposal.additionalServices) === null || _proposal$additionalS3 === void 0 ? void 0 : (_proposal$additionalS4 = _proposal$additionalS3.activities) === null || _proposal$additionalS4 === void 0 ? void 0 : _proposal$additionalS4.filter(function (obj) {
    return obj.pricingInfo.isPartiallyRented === true;
  });
  var equipments = proposal === null || proposal === void 0 ? void 0 : (_proposal$additionalS5 = proposal.additionalServices) === null || _proposal$additionalS5 === void 0 ? void 0 : (_proposal$additionalS6 = _proposal$additionalS5.rentals) === null || _proposal$additionalS6 === void 0 ? void 0 : _proposal$additionalS6.filter(function (rental) {
    return rental.pricingInfo.isPartiallyRented === true;
  });
  var transferUpsell = proposal === null || proposal === void 0 ? void 0 : (_proposal$additionalS7 = proposal.additionalServices) === null || _proposal$additionalS7 === void 0 ? void 0 : (_proposal$additionalS8 = _proposal$additionalS7.transfers) === null || _proposal$additionalS8 === void 0 ? void 0 : _proposal$additionalS8.filter(function (obj) {
    return obj.pricingInfo.isFullyRented === true;
  });
  var sumPriceAllActivities = price.excursions.value + price.sports.value + price.wellness.value + equipments.map(function (equipment) {
    return equipment.pricingInfo.rentedAmount.value;
  }).reduce(function (acc, currentValue) {
    return acc + currentValue;
  }, 0);
  var hasTransports = proposal.transports !== null;
  var hasActivities = activities.length > 0;
  var hasEquipments = equipments.length > 0;
  var hasTransfer = transferUpsell.length > 0 || hasTransports;
  var accommodationsIds = accommodations.map(function (accommodation) {
    return accommodation.id;
  });
  var selectedAccommodations = resort.accommodations.filter(function (acc) {
    return accommodationsIds.includes(acc.id);
  });
  var bedroomsNames = selectedAccommodations.length > 1 ? selectedAccommodations.map(function (el) {
    return el.label;
  }).join(" ".concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('common.and'), " ")) : (_selectedAccommodatio = selectedAccommodations[0]) === null || _selectedAccommodatio === void 0 ? void 0 : _selectedAccommodatio.label;
  var transferLabels = getTransferLabels(proposal);
  var lines = [{
    iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_16__[/* ICONS */ "a"].DATE,
    topLeft: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('booking.common.dates'),
    bottomLeft: "".concat(Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_10__[/* getFormattedArrivalDate */ "f"])(proposal).slice(0, 6), " -\n            ").concat(Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_10__[/* getFormattedDepartureDate */ "g"])(proposal).slice(0, 6)),
    bottomRight: duration > 1 ? Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('booking.confirmation.nights', {
      duration: duration
    }) : "".concat(duration, " ").concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('booking.confirmation.night')),
    isFirstItem: true
  }, {
    iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_16__[/* ICONS */ "a"].PEOPLE_DOUBLE,
    topLeft: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('booking.common.participants'),
    bottomLeft: Object(_utils_participants_participants_utils__WEBPACK_IMPORTED_MODULE_17__[/* getNumberOfAdultsAndChildren */ "b"])(quantityOfChildren, quantityOfAdults)
  }, {
    iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_16__[/* ICONS */ "a"].ACCOMODATIONS,
    bottomLeft: bedroomsNames,
    children: accommodationSummary,
    labelGA: 'receipt_room',
    isOpenedByDefault: true,
    topLeft: Object(_utils_accommodation_accommodation_utils__WEBPACK_IMPORTED_MODULE_18__[/* roomQuantity */ "b"])(accommodations)[0] > 1 || selectedAccommodations.length > 1 ? Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('booking.confirmation.rooms') : Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('booking.confirmation.room'),
    trackingData: {
      payload: {
        detail_click: 'receipt_room'
      }
    }
  }, {
    iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_16__[/* ICONS */ "a"].TRANSFER,
    isNull: !hasTransfer,
    bottomLeft: transferLabels,
    labelGA: 'receipt_transfert',
    topLeft: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('common.transport.transfer.withTransferLabel'),
    topRight: transferUpsell.length > 0 && __jsx(_StaySummaryTicketUpsell__WEBPACK_IMPORTED_MODULE_11__[/* StaySummaryTicketUpsell */ "a"], {
      transferUpsell: transferUpsell,
      price: price
    }),
    trackingData: {
      payload: {
        detail_click: 'receipt_transfert'
      }
    }
  }, {
    iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_16__[/* ICONS */ "a"].TRANSPORT,
    isNull: !hasTransports,
    bottomLeft: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('booking.confirmation.inboundAndOutbound'),
    topLeft: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('common.transport.withTransportLabel'),
    isOpenedByDefault: true,
    labelGA: 'receipt_transport',
    children: __jsx("div", {
      className: "mb-15"
    }, __jsx(_be_transport_details_BeTransportDetails__WEBPACK_IMPORTED_MODULE_12__[/* BeTransportDetails */ "a"], {
      transport: proposal === null || proposal === void 0 ? void 0 : proposal.transports,
      withoutTitle: true
    })),
    trackingData: {
      payload: {
        detail_click: 'receipt_transport'
      }
    }
  }, {
    iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_16__[/* ICONS */ "a"].KIDS,
    isNull: childcaresUpsell.length === 0,
    bottomLeft: Object(_utils_childcare_childcare_utils__WEBPACK_IMPORTED_MODULE_19__[/* displayChildcaresNames */ "c"])(proposal, childcaresUpsell),
    children: __jsx(_childcare_summary_ChildcareSummary__WEBPACK_IMPORTED_MODULE_14__[/* ChildcareSummary */ "a"], {
      childcares: childcaresUpsell,
      proposal: proposal
    }),
    dataTestId: 'childcare-button',
    topLeft: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('common.price.childcareLabel'),
    topRight: childcares.length > 0 && __jsx(_StaySummaryTicketUpsell__WEBPACK_IMPORTED_MODULE_11__[/* StaySummaryTicketUpsell */ "a"], {
      transferUpsell: transferUpsell,
      childcares: childcares,
      price: price
    }),
    trackingData: {
      payload: {
        detail_click: 'receipt_childcare'
      }
    }
  }, {
    iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_16__[/* ICONS */ "a"].TENNIS,
    isNull: !hasActivities && !hasEquipments,
    bottomLeft: Object(_utils_activity_activity_utils__WEBPACK_IMPORTED_MODULE_20__[/* displayActivitiesAndEquipmentsNames */ "a"])(hasActivities, hasEquipments, activities, equipments),
    bottomRight: '+' + Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_13__[/* formatAmountForLocale */ "b"])(sumPriceAllActivities, locale, undefined, {
      precision: 2
    }),
    children: __jsx("div", {
      className: "mt-30"
    }, __jsx(_GetParticipantsActivities__WEBPACK_IMPORTED_MODULE_15__[/* GetParticipantsActivities */ "a"], {
      proposal: proposal,
      participants: proposal.attendees.adults,
      isChild: false
    }), __jsx(_GetParticipantsActivities__WEBPACK_IMPORTED_MODULE_15__[/* GetParticipantsActivities */ "a"], {
      proposal: proposal,
      participants: proposal.attendees.children,
      isChild: true
    })),
    dataTestId: 'activities-button',
    topLeft: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('common.activities.label'),
    topRight: __jsx("p", {
      className: "text-14 font-bold text-orange"
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('booking.confirmation.onDemand')),
    trackingData: {
      payload: {
        detail_click: 'receipt_activities'
      }
    }
  }];
  return lines;
};

/***/ }),

/***/ "sEDY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectedRate; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("kiXb");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;



var FLEX_RATES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["constants"].FLEX_RATES;

var getLabel = function getLabel(_ref) {
  var selectedRate = _ref.selectedRate;

  switch (selectedRate) {
    case FLEX_RATES.NRR:
      return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.accommodation.stickyPrice.nonRefundableRateLabel');

    case FLEX_RATES.FLR:
      return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.accommodation.packageContent.flexibleRateLabel');

    default:
      return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.accommodation.packageContent.standardLabel');
  }
};

var SelectedRate = function SelectedRate(_ref2) {
  var price = _ref2.price;
  return __jsx("span", {
    className: "block leading-1 font-bold text-12 text-center text-white whitespace-nowrap",
    "data-testid": "selected-rate-content"
  }, getLabel(price));
};

/***/ }),

/***/ "sORq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccordionBlock; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _AccordionItem__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("7E63");










var __jsx = react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var AccordionBlock = function AccordionBlock(_ref) {
  var trackingEventName = _ref.trackingEventName,
      lines = _ref.lines,
      children = _ref.children;
  return __jsx("div", null, lines.map(function (props, index) {
    return __jsx(_AccordionItem__WEBPACK_IMPORTED_MODULE_11__[/* AccordionItem */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])({
      key: index
    }, props, {
      trackingData: _objectSpread(_objectSpread({}, props.trackingData), {}, {
        event: trackingEventName || props.trackingData.event
      })
    }));
  }), children);
};

/***/ })

}]);